var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldSearchSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_x2F_bold_x2F_search-setting_00000183935051976504865800000008925418991810895260_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24,0L24,0v24H0V0H24z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_x2F_bold_x2F_search-setting"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-setting"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "{props.color}",
    d: "M2,11c0,5,4,9,9,9s9-4,9-9s-4-9-9-9S2,6,2,11z M14.2,8.7c0-0.2,0.1-0.4,0.2-0.7c0.3-0.5,0.1-1.1-0.4-1.4 l-0.9-0.5c-0.4-0.2-1-0.1-1.2,0.3l-0.1,0.1c-0.5,0.8-1.3,0.8-1.7,0l-0.1-0.1C9.8,6,9.3,5.9,8.9,6.1L7.9,6.6 C7.6,6.8,7.4,7.2,7.4,7.5c0,0.2,0.1,0.3,0.1,0.5c0.1,0.2,0.2,0.5,0.2,0.7c0,0.5-0.4,0.8-1.1,0.8c-0.6,0-1,0.4-1,1v0.9 c0,0.6,0.5,1,1,1c0.7,0,1.1,0.3,1.1,0.8c0,0.2-0.1,0.4-0.2,0.7c-0.3,0.5-0.1,1.1,0.4,1.4l0.9,0.5c0.4,0.3,1,0.1,1.2-0.3l0.1-0.1 c0.5-0.8,1.3-0.8,1.7,0l0.1,0.1c0.2,0.4,0.8,0.6,1.2,0.3l0.9-0.5c0.3-0.2,0.5-0.5,0.5-0.9c0-0.2,0-0.3-0.1-0.5 c-0.1-0.2-0.2-0.5-0.2-0.7c0-0.5,0.4-0.8,1.1-0.8c0.6,0,1-0.4,1-1v-0.9c0-0.6-0.4-1-1-1C14.6,9.5,14.2,9.2,14.2,8.7z M9.3,11 c0-1,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7C10,12.7,9.3,11.9,9.3,11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000116206211014353706680000009482902865106953142_",
    fill: "{props.color}",
    d: "M20,18c-0.7,0-1.3,0.3-1.7,0.8 s-0.4,1.2-0.2,1.8c0.4,1.3,1.2,1.6,1.6,1.6c0.1,0,0.1,0,0.2,0c0.4,0,1.1-0.2,1.8-1.2c0.5-0.8,0.6-1.5,0.3-2.1 C21.7,18.3,21,18,20,18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000098180934384643355230000013416479819814188455_",
    fill: "none",
    d: "M0,24V0h24v24H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSearchSetting);
export default __webpack_public_path__ + "static/media/vuesax-bold-search-setting.9c96c3ac2f4a3122b2224e34b6d5a57c.svg";
export { ForwardRef as ReactComponent };